module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-250.14bfda9.woff2";